import { logger } from './logger';
// TODO: Move to HTTP Client. #296900
export const createRequestCache = () => {
    const requestCache = new Map();
    return (request, key) => {
        const cachedPromise = requestCache.get(key);
        if (cachedPromise) {
            logger.trace(`Returning cached promise for key '${key}'`);
            return cachedPromise;
        }
        const requestPromise = request();
        requestCache.set(key, requestPromise);
        const removeRequestFromCache = () => requestCache.delete(key);
        requestPromise.then(removeRequestFromCache, removeRequestFromCache);
        return requestPromise;
    };
};
export const getKeyForRequest = (url, requestConfig) => {
    return JSON.stringify([url, requestConfig === null || requestConfig === void 0 ? void 0 : requestConfig.urlParams, requestConfig === null || requestConfig === void 0 ? void 0 : requestConfig.queryParams]);
};
//# sourceMappingURL=request-cache.js.map